import React from 'react'

import { SxProps } from '@mui/material'

import { useAnalysisType } from 'redux/hooks/AnalysisTypes'
import { useTranslation } from 'language/translator'

import ContentBox from 'components_new/molecules/ContentBox'
import StatusBox from 'components_new/molecules/StatusBox'

import AnalysisTypeDescription from 'components_new/organisms/analysis_types/AnalysisTypeDescription'
import AnalysisTypeDetails from 'components_new/organisms/analysis_types/AnalysisTypeDetails'
import AnalysisTypeNoiImpact from 'components_new/organisms/analysis_types/AnalysisTypeNoiImpact'

import { isMissingConfiguration } from 'utils/analysis'

interface AnalysisTypeSummaryProps {
  /** Where it shows: the run dialog or the analysis type's own page. */
  context: 'dialog' | 'page'
  id: string
  sx?: SxProps
}

/**
 * The analysis type description, its missing-data notice, how it moves
 * driftnettot and what it uses.
 */
const AnalysisTypeSummary = (props: AnalysisTypeSummaryProps) => {
  const { context, id, sx } = props

  const { analysisType } = useAnalysisType(id)
  const { t } = useTranslation()

  if (!analysisType) return null

  return (
    <>
      <AnalysisTypeDescription context={context} id={id} />
      {isMissingConfiguration(analysisType) ? (
        <StatusBox
          allowClose={false}
          color="warning"
          severity="info"
          size="small"
          sx={{ mb: 2, width: '100%' }}
          title={t('analysis_types', 'disabled_title')}
        >
          {t('analysis_types', 'disabled_body')}
        </StatusBox>
      ) : null}
      <AnalysisTypeNoiImpact id={id} />
      <ContentBox
        border={true}
        collapse={{
          active: true,
          defaultCollapsed: !isMissingConfiguration(analysisType)
        }}
        header={{
          color: 'secondary',
          divider: true,
          title: t('analysis_types', 'analysis_type_uses_title')
        }}
        sx={sx}
      >
        <AnalysisTypeDetails id={id} />
      </ContentBox>
    </>
  )
}

export default AnalysisTypeSummary
